const GAMIFY_API_BASE_PATH = '/v3/gamify';

export const GAMIFY_OBJECTIVE_SETS_CURRENT_API_PATH = `${GAMIFY_API_BASE_PATH}/set/current`;
export const GAMIFY_OBJECTIVE_CLAIM_API_PATH = `${GAMIFY_API_BASE_PATH}/objective/claim`;
export const GAMIFY_STREAK_API_PATH = `${GAMIFY_API_BASE_PATH}/streak`;
export const GAMIFY_STREAK_CLAIM_API_PATH = `${GAMIFY_API_BASE_PATH}/streak/claim`;
export const GAMIFY_RECURRING_REWARDS_API_PATH = `${GAMIFY_API_BASE_PATH}/recurring-rewards`;
export const gamifyRecurringRewardClaimApiPath = (reward: string) =>
    `${GAMIFY_RECURRING_REWARDS_API_PATH}/${encodeURIComponent(reward)}/claim`;
